import { DateTime } from 'luxon'

type PaginatedParams = {
  page: number
  hitsPerPage: number
}

export async function fetchAllPages<T, P extends Record<string, any>>(
  fn: (params: P & PaginatedParams) => Promise<T[]>,
  params: P,
  options?: {
    hitsPerPage?: number
    startPage?: number
    chunkSize?: number
  }
): Promise<T[]> {
  // Crée un tableau de dates entre startDate et endDate inclus
  const days: DateTime[] = []
  const { startDate, endDate, before, after, ...otherParams } = params
  const start = startDate || (after as Date)
  const end = endDate || (before as Date)

  let current = DateTime.fromJSDate(start)
  const last = DateTime.fromJSDate(end)

  while (current <= last) {
    days.push(current)
    current = current.plus({ days: 1 })
  }

  const results: T[] = []

  for (const day of days) {
    //@ts-expect-error
    const newParams = {
      ...otherParams,
      ...(startDate ? { startDate: day.startOf('day').toJSDate() } : { after: day.startOf('day').toJSDate() }),
      ...(endDate ? { endDate: day.endOf('day').toJSDate() } : { before: day.endOf('day').toJSDate() }),
    } as P
    const result = await fetchDayPages(fn, newParams, options)

    results.push(...result)
  }

  return results
}

async function fetchDayPages<T, P extends Record<string, any>>(
  fn: (params: P & PaginatedParams) => Promise<T[]>,
  params: P,
  options?: {
    hitsPerPage?: number
    startPage?: number
  }
): Promise<T[]> {
  const hitsPerPage = options?.hitsPerPage ?? 10000
  let page = options?.startPage ?? 1

  const results: T[] = []

  while (true) {
    const data = await fn({
      ...params,
      page,
      hitsPerPage,
    })

    results.push(...data)
    if (data.length < hitsPerPage) break

    page++
  }

  return results
}
